exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pending-confirmation-container-3ZqxC {\n  text-align: center;\n}\n.pending-confirmation-message-container-BI5LW {\n  margin-top: 10px;\n}\n.pending-confirmation-resend-button-ctOLr {\n  width: 60%;\n}", ""]);

// Exports
exports.locals = {
	"pending-confirmation-container": "pending-confirmation-container-3ZqxC",
	"pending-confirmation-message-container": "pending-confirmation-message-container-BI5LW",
	"pending-confirmation-resend-button": "pending-confirmation-resend-button-ctOLr"
};